import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import FormPage from '../components/FormPage'

@inject('message') @observer
class FormContainer extends Component {

  static propTypes = {
    router: PropTypes.shape({
      goBack: PropTypes.func.isRequired,
    }).isRequired,
  }

  @autobind
  handleClose() {
    this.props.router.goBack()
  }

  render() {
    return (
      <FormPage
        onClose={this.handleClose}
      />
    )
  }
}

const FormContainerWithRouter = withRouter(FormContainer)

export { FormContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/message/containers/FormContainer.js